module.exports = __webpack_public_path__ + "static/media/es.e6a28e06.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/es.svg
// module id = 815
// module chunks = 0